var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prompt"},[_c('p',[_vm._v("Successfully copied to clipboard")])])
}]

export { render, staticRenderFns }